export default {
  id: null,
  descricao: null,
  cliente: null,
  regiao: null,
  revisao: 1,
  observacao: null,
  itens: [],
  colunas: [],
  status: 1
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/lpumodel.js